<template>
  <video-player
    ref="videoPlayer"
    :playsinline="true"
    :options="playerOptions"/>
</template>
<script>
  import 'video.js/dist/video-js.css'
  const videoPlayer = () => import(/* webpackChunkName: "vue-video-player" */ 'vue-video-player/src/player')
  const videoOptions = {
    playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选择的播放速度
    autoplay: false, // 如果true,浏览器准备好时开始回放。
    muted: false, // 默认情况下将会消除任何音频。
    loop: false, // 视频一结束就重新开始。
    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
    language: 'zh-CN',
    aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
    sources: [],
    poster: '', // 你的封面地址
    notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
    controlBar: {
      fullscreenToggle: false // 全屏按钮
    }
  }
  export default {
    name: 'RcVideo',
    components: {
      videoPlayer
    },
    props: {
      videoSrc: {
        type: String,
        required: true
      },
      options: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    computed: {
      playerOptions () {
        return Object.assign({}, videoOptions, this.options, { sources: [{ type: 'video/mp4', src: this.videoSrc }] })
      }
    },
    methods: {
      // 暂停
      pause () {
        this.$refs.videoPlayer.player.pause()
      },
      // 播放
      play () {
        this.$refs.videoPlayer.player.play()
      },
      // 重置
      reset () {
        this.$refs.videoPlayer.player.src(this.videoSrc)
      }
    }
  }
</script>
